import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AiToolConsentDecision } from '@domain/ai-assistant/ai-assistant.models';
import { AiToolCallPartVm } from '@domain/ai-assistant/ai-assistant.view-models';

import { AiAssistantService } from '../../ai-assistant.service';
import { AiConsentButtonsComponent } from '../ai-consent-buttons/ai-consent-buttons.component';

@Component({
  selector: 'app-ai-tool-call-part',
  imports: [AiConsentButtonsComponent],
  templateUrl: './ai-tool-call-part.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiToolCallPartComponent {
  public part = input.required<AiToolCallPartVm>();

  readonly #aiService = inject(AiAssistantService);
  readonly #translate = inject(TranslateService);

  public readonly label = computed(() => {
    const { toolName, toolArguments, complete } = this.part();
    const toolKey = toolName.replaceAll('_', '-');
    const reportType = complete ? getReportTypeKey(toolArguments) : undefined;
    const key = reportType ? `ai-assistant.tool-calls.${toolKey}-${reportType}` : `ai-assistant.tool-calls.${toolKey}`;
    const translated = this.#translate.instant(key);

    return translated === key ? this.#translate.instant('ai-assistant.tool-calls.fallback', { toolName }) : translated;
  });

  public onConsentDecision(decision: AiToolConsentDecision): void {
    const consentId = this.part().pendingConsentId;
    if (!consentId) return;
    this.#aiService.sendConsent(consentId, decision);
  }
}

function getReportTypeKey(toolArguments: string): string | undefined {
  const { reportType } = JSON.parse(toolArguments) as { reportType?: string };
  return reportType?.toLowerCase().replaceAll('_', '-');
}
